import { Controller, useFormContext } from 'react-hook-form';
import _ from 'lodash';
import CustomSelectInput from '../../CustomSelectInput/CustomSelectInput';
import { AsyncSelectField } from '../types';

const AsyncSelectFieldForm = ({ field }: { field: AsyncSelectField }) => {
  const {
    control,
    formState: { errors },
    setValue,
    getValues,
  } = useFormContext();
  const currentError = _.get(errors, field.key);

  return (
    <div>
      <Controller
        name={field.key}
        control={control}
        render={({ field: renderField }) => (
          <CustomSelectInput
            label={field.label}
            value={renderField.value ?? null}
            isDisabled={field.disabled as any}
            placeholder={field.placeholder}
            loadOptions={field.loadOptions as any}
            defaultOptions={field.defaultOptions}
            isOptionSelected={field.isOptionSelected}
            formatOptionLabel={field.formatOptionLabel as any}
            components={field.components}
            onChange={(val) => {
              renderField.onChange(val);
              field.onAfterChange?.(val, { setValue, getValues });
            }}
          />
        )}
      />
      {currentError && (
        <p className="text-danger" style={{ fontSize: 12 }}>
          {(currentError as any).message}
        </p>
      )}
    </div>
  );
};

export default AsyncSelectFieldForm;
